// extracted by mini-css-extract-plugin
export var head = "BasicSection-module--head--82d17";
export var section = "BasicSection-module--section--bc662";